import React, { useState } from "react";

function DropdownDot({ options, defaultSelected, formlable, bgcolor, name, handleDropDownChange }) {
    const [selectedOption, setSelectedOption] = useState(defaultSelected);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isWrapperSelected, setIsWrapperSelected] = useState(false); // New state

    const toggleDropdown = () => {
        setIsDropdownOpen(prevState => !prevState);
    };

    const handleOptionSelect = option => {
        setSelectedOption(option);
        handleDropDownChange(name, option);
        setIsWrapperSelected(true); // Add selected class to the wrapper
        toggleDropdown();
    };

    return (
        <div className={`form-box-color custom-select-container mb-3 ${isDropdownOpen ? 'open' : ''}`}>
            <div className="custom-form-group">
                <div className="zpil">
                    <div className="dot" style={{ backgroundColor: bgcolor }}></div>
                    <label className="dashboard-form-lable">{formlable}</label>
                </div>
                <div className={`custom-select-wrapper w-60 ${isDropdownOpen ? 'open' : ''} ${selectedOption.value > 0 ? 'selected' : ''}`}>
                    <div className="selected-option" onClick={toggleDropdown}>
                        <div className="custom-option-label2">
                            {
                                selectedOption.icon === '0' ? '' : <span className="option-icon">{selectedOption.icon}</span>
                            }
                            <span className="option-text">{selectedOption.label}</span>
                        </div>
                        <i className={`bi ${isDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                    </div>
                    {isDropdownOpen && (
                        <div className="options-list">
                            {options.map(option => (
                                <div
                                    key={option.value}
                                    className={`option ${selectedOption.value === option.value ? 'selected' : ''}`}
                                    onClick={() => handleOptionSelect(option)}
                                >
                                    <div className="custom-option-label">
                                        <span className="option-icon">{option.icon}</span>
                                        <span className="option-text">{option.label}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default DropdownDot;
